export const ACTIVITY_STAGES = {
  GENERAL: 1,
  TICKETS: 2,
  INCLUSIONS: 3,
  EXCLUSIONS: 4,
  ITINERARY: 5,
  PRICING: 6,
  CANCELLATION: 7,
  FAQ: 8,
  TERMS: 9,
};

export const ACTIVITY_MAX_STAGE = ACTIVITY_STAGES.TERMS;

export const isSectionCompleted = (
  completedStage,
  itemStage,
  isFreeBooking = false
) => {
  if (itemStage === ACTIVITY_STAGES.PRICING && isFreeBooking) return true;
  const stage = Number(completedStage) || 0;
  return (
    stage > itemStage ||
    (stage >= ACTIVITY_MAX_STAGE && itemStage === ACTIVITY_MAX_STAGE)
  );
};

export const isStageAccessible = (itemStage, savedStage) =>
  itemStage <= (Number(savedStage) || ACTIVITY_STAGES.GENERAL);

export const getActivityNextStage = (currentStage, isFreeBooking = false) => {
  const stage = Number(currentStage) || ACTIVITY_STAGES.GENERAL;

  switch (stage) {
    case ACTIVITY_STAGES.GENERAL:
      return ACTIVITY_STAGES.TICKETS;
    case ACTIVITY_STAGES.TICKETS:
      return ACTIVITY_STAGES.ITINERARY;
    case ACTIVITY_STAGES.ITINERARY:
      return isFreeBooking ? ACTIVITY_STAGES.FAQ : ACTIVITY_STAGES.PRICING;
    case ACTIVITY_STAGES.PRICING:
      return ACTIVITY_STAGES.FAQ;
    case ACTIVITY_STAGES.FAQ:
      return ACTIVITY_STAGES.TERMS;
    case ACTIVITY_STAGES.TERMS:
      return ACTIVITY_STAGES.TERMS;
    default:
      if (stage < ACTIVITY_STAGES.TICKETS) return ACTIVITY_STAGES.TICKETS;
      if (stage < ACTIVITY_STAGES.ITINERARY) return ACTIVITY_STAGES.ITINERARY;
      if (stage < ACTIVITY_STAGES.PRICING) {
        return isFreeBooking ? ACTIVITY_STAGES.FAQ : ACTIVITY_STAGES.PRICING;
      }
      if (stage < ACTIVITY_STAGES.FAQ) return ACTIVITY_STAGES.FAQ;
      return ACTIVITY_STAGES.TERMS;
  }
};

export const getEffectiveActivityCompletedStage = (
  savedStage,
  isFreeBooking = false
) => {
  const stage = Number(savedStage) || ACTIVITY_STAGES.GENERAL;
  if (isFreeBooking && stage >= ACTIVITY_STAGES.PRICING && stage < ACTIVITY_STAGES.FAQ) {
    return ACTIVITY_STAGES.FAQ;
  }
  return stage;
};

export const isActivitySectionAccessible = (
  targetStage,
  completedStage,
  hasActivityId,
  isEditingExisting = false
) => {
  if (isEditingExisting) return true;
  if (!hasActivityId) return targetStage === ACTIVITY_STAGES.GENERAL;
  const progress = getEffectiveActivityCompletedStage(completedStage);
  return targetStage <= progress;
};
